import ApiService from '../../../services/ApiService'
import Utils from '../../../Utils/FormatDate'
import moment from 'moment'

export default {
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id

    await Promise.all([
      this.fetchStats(),
      this.getUnidades(),
      this.getDepartments(),
      this.getStandardEquipments(),
    ])

    this.loadSavedColumns()

    await Promise.all([
      this.fetchCorretivas(),
      this.fetchMP(),
      this.fetchInspecao(),
    ])
  },

  data() {
    return {
      userLogged: {},
      institution: {},
      institutionId: null,
      tab: null,
      deleteDialog: false,
      loading: false,
      menuLoading: false,
      loadingCorretivas: false,
      loadingMP: false,
      loadingInspecao: false,
      headMenuCorretivas: false,
      headMenuMP: false,
      headMenuInspecao: false,
      filterVisibleCorretivas: false,
      filterVisibleMP: false,
      filterVisibleInspecao: false,
      toggleMP: 'atrasadas',
      toggleInspecao: 'atrasadas',
      menuStartDateCorretivas: false,
      menuEndDateCorretivas: false,
      menuStartDateMP: false,
      menuEndDateMP: false,
      menuStartDateInspecao: false,
      menuEndDateInspecao: false,
      unitSearch: '',
      sectorSearch: '',
      subSectorSearch: '',
      equipSearch: '',
      headerProps: { sortByText: 'Ordenar por' },
      sizes: [10, 30, 90, 180],
      unidades: [],
      departments: [],
      standardEquipments: [],
      orderToDelete: null,
      stats: {
        productivityHours: 0,
        resolutividadePercent: 0,
        conclusaoMPPercent: 0,
        openCount: 0,
      },
      filterCorretivas: {
        unidadeIds: [],
        equipmentDepartmentIds: [],
        subDepartmentIds: [],
        standardEquipmentIds: [],
        status: [],
        requestStartDate: null,
        requestEndDate: null,
      },
      filterMP: {
        unidadeIds: [],
        equipmentDepartmentIds: [],
        subDepartmentIds: [],
        standardEquipmentIds: [],
        status: [],
        requestStartDate: null,
        requestEndDate: null,
      },
      filterInspecao: {
        unidadeIds: [],
        equipmentDepartmentIds: [],
        subDepartmentIds: [],
        standardEquipmentIds: [],
        status: [],
        requestStartDate: null,
        requestEndDate: null,
      },
      statusOptions: [
        { text: 'Abertas', value: 0 },
        { text: 'Fechadas', value: 1 },
      ],
      serviceOrderTypes: [
        'Treinamento',
        'Segurança elétrica',
        'Preventiva',
        'Instalação',
        'Rotina de Inspeção',
        'Corretiva',
        'Calibração',
        'Validação/Qualificação',
        'Serviço Administrativo',
        'Empréstimo',
        null,
        'Obras',
        'Serviço Operacional',
      ],
      ordersCorretivas: [],
      pageCorretivas: 1,
      pageSizeCorretivas: 10,
      totalItemsCorretivas: 0,
      ordersMP: [],
      pageMP: 1,
      pageSizeMP: 10,
      totalItemsMP: 0,
      ordersInspecao: [],
      pageInspecao: 1,
      pageSizeInspecao: 10,
      totalItemsInspecao: 0,
      headersCorretivas: [
        { text: 'Nº O.S.', value: 'number', active: true, align: 'center' },
        {
          text: 'Unidade',
          value: 'unidade.name',
          active: true,
          align: 'center',
        },
        {
          text: 'Setor',
          value: 'department.name',
          active: true,
          align: 'center',
        },
        {
          text: 'Sub-Setor',
          value: 'subDepartment.name',
          active: false,
          align: 'center',
        },
        {
          text: 'Equipamento Padrão',
          value: 'equipment.standardEquipment.name',
          active: true,
          align: 'center',
        },
        {
          text: 'Fabricante',
          value: 'equipment.manufacturer',
          active: false,
          align: 'center',
        },
        {
          text: 'Modelo',
          value: 'equipment.model',
          active: false,
          align: 'center',
        },
        {
          text: 'Identificação',
          value: 'equipment.identification',
          active: true,
          align: 'center',
        },
        {
          text: 'Data Solicitação',
          value: 'dateTimeRequest',
          active: true,
          align: 'center',
        },
        {
          text: 'Criticidade / Urgência',
          value: 'criticidade',
          active: true,
          align: 'center',
          sortable: false,
        },
        {
          text: 'SLA Máximo Atendimento',
          value: 'slaAttendance',
          active: true,
          align: 'center',
          sortable: false,
        },
        {
          text: 'SLA Máximo Resolução',
          value: 'slaResolution',
          active: true,
          align: 'center',
          sortable: false,
        },
        {
          text: 'Ações',
          value: 'actions',
          active: true,
          align: 'center',
          sortable: false,
        },
      ],
      headersMP: [
        { text: 'Nº O.S.', value: 'number', active: true, align: 'center' },
        {
          text: 'Unidade',
          value: 'unidade.name',
          active: true,
          align: 'center',
        },
        {
          text: 'Setor',
          value: 'department.name',
          active: true,
          align: 'center',
        },
        {
          text: 'Sub-Setor',
          value: 'subDepartment.name',
          active: false,
          align: 'center',
        },
        {
          text: 'Tipo OS',
          value: 'serviceOrderType',
          active: true,
          align: 'center',
        },
        {
          text: 'Equipamento Padrão',
          value: 'equipment.standardEquipment.name',
          active: true,
          align: 'center',
        },
        {
          text: 'Fabricante',
          value: 'equipment.manufacturer',
          active: false,
          align: 'center',
        },
        {
          text: 'Modelo',
          value: 'equipment.model',
          active: false,
          align: 'center',
        },
        {
          text: 'Identificação',
          value: 'equipment.identification',
          active: true,
          align: 'center',
        },
        {
          text: 'Data Solicitação',
          value: 'dateTimeRequest',
          active: true,
          align: 'center',
        },
        {
          text: 'Criticidade / Urgência',
          value: 'criticidade',
          active: true,
          align: 'center',
          sortable: false,
        },
        {
          text: 'Ações',
          value: 'actions',
          active: true,
          align: 'center',
          sortable: false,
        },
      ],
      headersInspecao: [
        { text: 'Nº O.S.', value: 'number', active: true, align: 'center' },
        {
          text: 'Unidade',
          value: 'unidade.name',
          active: true,
          align: 'center',
        },
        {
          text: 'Setor',
          value: 'department.name',
          active: true,
          align: 'center',
        },
        {
          text: 'Sub-Setor',
          value: 'subDepartment.name',
          active: false,
          align: 'center',
        },
        { text: 'Nome da OS', value: 'name', active: true, align: 'center' },
        {
          text: 'Data Solicitação',
          value: 'dateTimeRequest',
          active: true,
          align: 'center',
        },
        {
          text: 'Ações',
          value: 'actions',
          active: true,
          align: 'center',
          sortable: false,
        },
      ],
      apiService: new ApiService(),
    }
  },

  computed: {
    totalPagesCorretivas() {
      return Math.ceil(this.totalItemsCorretivas / this.pageSizeCorretivas) || 1
    },
    totalPagesMP() {
      return Math.ceil(this.totalItemsMP / this.pageSizeMP) || 1
    },
    totalPagesInspecao() {
      return Math.ceil(this.totalItemsInspecao / this.pageSizeInspecao) || 1
    },
    subDepartmentsCorretivas() {
      return this.departments
        .filter((d) => this.filterCorretivas.equipmentDepartmentIds && this.filterCorretivas.equipmentDepartmentIds.includes(d.id))
        .flatMap((d) => d.subDepartments || [])
    },
    subDepartmentsMP() {
      return this.departments
        .filter((d) => this.filterMP.equipmentDepartmentIds && this.filterMP.equipmentDepartmentIds.includes(d.id))
        .flatMap((d) => d.subDepartments || [])
    },
    subDepartmentsInspecao() {
      return this.departments
        .filter((d) => this.filterInspecao.equipmentDepartmentIds && this.filterInspecao.equipmentDepartmentIds.includes(d.id))
        .flatMap((d) => d.subDepartments || [])
    },
  },

  watch: {
    pageCorretivas() { this.fetchCorretivas() },
    pageMP() { this.fetchMP() },
    pageInspecao() { this.fetchInspecao() },
    toggleMP() { this.pageMP = 1; this.fetchMP() },
    toggleInspecao() { this.pageInspecao = 1; this.fetchInspecao() },
  },

  methods: {
    async fetchStats() {
      await this.apiService
        .get('serviceorder/my-tasks/stats', null, true, false)
        .then((response) => {
          this.stats = response.content
        })
        .catch(() => {})
    },

    async fetchCorretivas() {
      this.loadingCorretivas = true
      await this.apiService
        .post('serviceorder/my-tasks/corretivas', {
          ...this.filterCorretivas,
          apenasAbertas: true,
          page: this.pageCorretivas,
          pageSize: this.pageSizeCorretivas,
          institutionId: this.institutionId,
        })
        .then((response) => {
          this.ordersCorretivas = response.content.orders
          this.totalItemsCorretivas = response.content.totalItems
        })
        .catch(() => {})
        .finally(() => { this.loadingCorretivas = false })
    },

    async fetchMP() {
      this.loadingMP = true
      await this.apiService
        .post('serviceorder/my-tasks/mp', {
          ...this.filterMP,
          apenasAbertas: true,
          apenasDoMes: this.toggleMP === 'mes' || null,
          atrasadasMes: this.toggleMP === 'atrasadas' || null,
          page: this.pageMP,
          pageSize: this.pageSizeMP,
          institutionId: this.institutionId,
        })
        .then((response) => {
          this.ordersMP = response.content.orders
          this.totalItemsMP = response.content.totalItems
        })
        .catch(() => {})
        .finally(() => { this.loadingMP = false })
    },

    async fetchInspecao() {
      this.loadingInspecao = true
      await this.apiService
        .post('serviceorder/my-tasks/inspecao', {
          ...this.filterInspecao,
          apenasAbertas: true,
          apenasHoje: this.toggleInspecao === 'dia' || null,
          atrasadasDia: this.toggleInspecao === 'atrasadas' || null,
          page: this.pageInspecao,
          pageSize: this.pageSizeInspecao,
          institutionId: this.institutionId,
        })
        .then((response) => {
          this.ordersInspecao = response.content.orders
          this.totalItemsInspecao = response.content.totalItems
        })
        .catch(() => {})
        .finally(() => { this.loadingInspecao = false })
    },

    applyFilterCorretivas() {
      this.pageCorretivas = 1
      this.fetchCorretivas()
    },

    clearFilterCorretivas() {
      this.filterCorretivas = { unidadeIds: [], equipmentDepartmentIds: [], subDepartmentIds: [], standardEquipmentIds: [], status: [], requestStartDate: null, requestEndDate: null }
      this.applyFilterCorretivas()
    },

    removeFromFilterCorretivas(key, item) {
      this.filterCorretivas[key] = this.filterCorretivas[key].filter((v) => v !== item.id && v !== item.value)
    },

    applyFilterMP() {
      this.pageMP = 1
      this.fetchMP()
    },

    clearFilterMP() {
      this.filterMP = { unidadeIds: [], equipmentDepartmentIds: [], subDepartmentIds: [], standardEquipmentIds: [], status: [], requestStartDate: null, requestEndDate: null }
      this.applyFilterMP()
    },

    removeFromFilterMP(key, item) {
      this.filterMP[key] = this.filterMP[key].filter((v) => v !== item.id && v !== item.value)
    },

    applyFilterInspecao() {
      this.pageInspecao = 1
      this.fetchInspecao()
    },

    clearFilterInspecao() {
      this.filterInspecao = { unidadeIds: [], equipmentDepartmentIds: [], subDepartmentIds: [], standardEquipmentIds: [], status: [], requestStartDate: null, requestEndDate: null }
      this.applyFilterInspecao()
    },

    removeFromFilterInspecao(key, item) {
      this.filterInspecao[key] = this.filterInspecao[key].filter((v) => v !== item.id && v !== item.value)
    },

    async getUnidades() {
      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content || []
        })
        .catch(() => {})
    },

    async getDepartments() {
      await this.apiService
        .get(`department/list/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content || []
        })
        .catch(() => {})
    },

    async getStandardEquipments() {
      await this.apiService
        .get(`standardEquipment/list/${this.institutionId}`)
        .then((response) => {
          this.standardEquipments = response.content || []
        })
        .catch(() => {})
    },

    loadSavedColumns() {
      const saved = this.userLogged.myTasksColumns
        ? JSON.parse(this.userLogged.myTasksColumns)
        : null

      if (!saved) return

      if (saved.corretivas) {
        this.headersCorretivas = this.headersCorretivas.map((h) => {
          const found = saved.corretivas.find((s) => s.text === h.text)
          return found ? { ...h, active: found.active } : h
        })
      }

      if (saved.mp) {
        this.headersMP = this.headersMP.map((h) => {
          const found = saved.mp.find((s) => s.text === h.text)
          return found ? { ...h, active: found.active } : h
        })
      }

      if (saved.inspecao) {
        this.headersInspecao = this.headersInspecao.map((h) => {
          const found = saved.inspecao.find((s) => s.text === h.text)
          return found ? { ...h, active: found.active } : h
        })
      }
    },

    saveColumns(tab) {
      this.menuLoading = true

      const payload = {
        corretivas: this.headersCorretivas,
        mp: this.headersMP,
        inspecao: this.headersInspecao,
      }

      const json = JSON.stringify(payload)

      this.apiService
        .post('user/saveColumns/my-tasks', { columns: json })
        .then(() => {
          this.userLogged.myTasksColumns = json
          localStorage.setItem('user', JSON.stringify(this.userLogged))
          this.$toast.success('Configuração salva no seu usuário!')

          if (tab === 'corretivas') this.headMenuCorretivas = false
          else if (tab === 'mp') this.headMenuMP = false
          else this.headMenuInspecao = false
        })
        .finally(() => {
          this.menuLoading = false
        })
    },

    goToServiceOrder(item) {
      this.$router.push(`/editServiceOrder/${item.id}`)
    },

    editServiceOrder(item) {
      this.$router.push(`/editServiceOrder/${item.id}`)
    },

    printServiceOrder(item) {
      const route = this.$router.resolve({
        path: `printServiceOrder/${this.institutionId}/${item.id}`,
      })
      window.open(route.href, '_blank')
    },

    askDelete(item) {
      this.orderToDelete = item
      this.deleteDialog = true
    },

    async confirmDelete() {
      if (!this.orderToDelete) return
      this.loading = true

      await this.apiService
        .delete('serviceorder/delete', {
          serviceOrderId: this.orderToDelete.id,
        })
        .then(() => {
          this.$toast.success('Ordem de serviço excluída!')
          this.deleteDialog = false
          this.orderToDelete = null
          this.applyFilter()
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    getCriticidade(item) {
      const criticality = item.equipment ? item.equipment.criticality : null
      if (criticality === null || criticality === undefined)
        return 'Sem registro'
      if (criticality >= 19) return 'Alta'
      if (criticality >= 12) return 'Média'
      if (criticality >= 3) return 'Baixa'
      return 'Sem registro'
    },

    getSlaDeadline(item, type) {
      if (!item.unidade || !item.equipment || !item.dateTimeRequest) return null
      const c = item.equipment.criticality
      let hours = null
      if (type === 'attendance') {
        if (c >= 19) hours = item.unidade.serviceTimeEquipmentHighCriticality
        else if (c >= 12) hours = item.unidade.serviceTimeEquipmentMediumCriticality
        else if (c >= 3) hours = item.unidade.serviceTimeEquipmentLowCriticality
      } else {
        if (c >= 19) hours = item.unidade.resolutionTimeEquipmentHighCriticality
        else if (c >= 12) hours = item.unidade.resolutionTimeEquipmentMediumCriticality
        else if (c >= 3) hours = item.unidade.resolutionTimeEquipmentLowCriticality
      }
      if (!hours) return null
      const deadline = moment(item.dateTimeRequest).add(Number(hours), 'hours')
      return deadline.isValid() ? deadline.toDate() : null
    },

    formatSlaDate(date) {
      if (!date) return 'Sem registro'
      const m = moment(date)
      return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : 'Sem registro'
    },

    getSlaAttendance(item) {
      const date = this.getSlaDeadline(item, 'attendance')
      return this.formatSlaDate(date)
    },

    isSlaAttendanceOverdue(item) {
      const date = this.getSlaDeadline(item, 'attendance')
      return date ? date < new Date() : false
    },

    getSlaResolution(item) {
      const date = this.getSlaDeadline(item, 'resolution')
      return this.formatSlaDate(date)
    },

    isSlaResolutionOverdue(item) {
      const date = this.getSlaDeadline(item, 'resolution')
      return date ? date < new Date() : false
    },

    setChecklistButtonColor(item) {
      return item.checklistServiceOrders &&
        item.checklistServiceOrders.length > 0 &&
        item.checklistServiceOrders[0].checklistResponse != null
        ? '#BBCF20'
        : '#426483'
    },
  },
}
